import { Tween, Easing } from "@tweenjs/tween.js";
import { formatCurrencyValue, getCurrencySymbol } from "../helper/currencies";
import { COMPONENTS, EVENTS } from "../../lib/constants";
import { GameConfigs } from "../../lib/globals/GameConfigs";
import HELPERS from "../../lib/globals/helpers/Helpers";
import { QuestPromptView } from "../../view/quest/QuestPromptView";
import { QuestStatusBarView } from "../../view/quest/QuestStatusBar";

class BonusGameFinishedController {
  constructor(vc, conf) {
    this.config = conf;
    this.win = 0;
    this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency, true);
    // this.reels = vc.parent.parent.parent.reels
    if (vc[this.config.item]) {
      this.vc = vc[this.config.item];
      this.updateWin(GameConfigs.bonusRoundData.totalWin);
      // this.updateWin(1000);
      this.vc.text_3.alpha = 0;
      this.vc.text_3.scale.set(4);
      this.addEventListeners();
      HELPERS.disableAllButtons(true);
      if (GameConfigs.settings.background_music) {
        window.sm.play({
          name: "bg_music_lvl4_v2",
          loop: true,
          background: true,
        });
      }
    } else {
      throw new Error(
        "BonusGameFinishedController " + JSON.stringify(this.config)
      );
    }
  }

  addEventListeners() {
    setTimeout(() => {
      if (
        GameConfigs.settings.keyboard_shortcuts &&
        !window.isMobile &&
        !window.isTablet
      ) {
        window.addEventListener("keydown", this, false);
      }
      window.addEventListener(EVENTS.INTERACTION, this, false);
    }, 500);
  }

  removeEventListeners() {
    window.removeEventListener(EVENTS.INTERACTION, this, false);
    window.removeEventListener("keydown", this, false);
  }

  handleEvent(evt) {
    switch (evt.type) {
      case EVENTS.INTERACTION:
        this.handleClick();
        break;
      case "keydown":
        if (
          (evt.keyCode === 27 || evt.keyCode === 32) &&
          GameConfigs.modal !== "fastplay_dialogue"
        ) {
          this.handleClick();
        }
        break;
      default:
        break;
    }
  }

  setWin() {
    this.vc.text_2.text = formatCurrencyValue(this.win, this.currency);
  }

  handleClick() {
    window.sm.stop("bg_music_lvl4_v2", 500);
    GameConfigs.config = { ...GameConfigs.config, hasbonus: false };
    if (GameConfigs.bonusRoundActivated === "finished") {
      GameConfigs.bonusRoundActivated = "";
      this.removeEventListeners();
      if (this.tweener || this.tweener.isPlaying()) {
        this.tweener.end();
        this.finishBonus();
      } else {
        this.finishBonus();
      }
    }
  }

  finishBonus() {
    this.timeout = setTimeout(() => {
      if (GameConfigs.modal === "bonus_game_finish") {
        if (
          GameConfigs.quest_current &&
          GameConfigs.quest_is_active &&
          GameConfigs.quest_current.status === "completed"
        ) {
          GameConfigs.quest_claim = {
            ...GameConfigs.quest_claim,
            activated_item: 0,
          };
          if (GameConfigs.uiComponent[COMPONENTS.QUEST_PROMPT] === undefined) {
            GameConfigs.uiComponent.addView(QuestPromptView);
            HELPERS.dispatchCustomEvent(EVENTS.MODAL, {
              modal: "quest_prompt",
            });
          }
        } else {
          HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: "" });
          HELPERS.disableAllButtons(false);
          if (
            GameConfigs.quest_current &&
            GameConfigs.quest_is_active &&
            GameConfigs.quest_current.step &&
            GameConfigs.quest_current.status === "inprogress"
          ) {
            if (GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]) {
              GameConfigs.uiComponent.removeView(
                GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]
              );
            }
            GameConfigs.uiComponent.addView(QuestStatusBarView);
          }
        }
      }
      HELPERS.dispatchCustomEvent(EVENTS.BONUS_ROUND_STATE, { state: "" });
      HELPERS.dispatchCustomEvent(EVENTS.BONUS_BUY, { bonus: false });
      if (GameConfigs.bonusRestore) {
        GameConfigs.bonusRestore = null;
      }
      if (GameConfigs.bonusRoundData) {
        GameConfigs.bonusRoundData = null;
      }
    }, 500);
  }

  updateWin(a) {
    this.tweener = new Tween(this)
      .to({ win: a }, 1000)
      .easing(Easing.Linear.None)
      .onUpdate(() => {
        this.setWin();
      })
      .start()
      .onComplete(() => {
        this.vc.text_3.alpha = 1;
        new Tween(this.vc.text_3.scale)
          .to({ x: 1, y: 1 }, 150)
          .easing(Easing.Linear.None)
          .start();
      });
  }
}

export default BonusGameFinishedController;
